import { SearchspringRecommendProvider } from '../fetchers/recommend'
import { BeaconAnalyticsProvider } from '../hooks/useBeaconAnalytics'

import { CarouselResults } from './CarouselResults'

export function CarouselRecommend({ profile, productId, itemClass }) {
  return (
    <SearchspringRecommendProvider profile={profile} productId={productId}>
      <BeaconAnalyticsProvider profile={profile}>
        <CarouselResults className={itemClass} hideControlsOnMobile={true} />
      </BeaconAnalyticsProvider>
    </SearchspringRecommendProvider>
  )
}
